import VxeButtonComponent from './src/button';
import { dynamicApp } from '../dynamics';
export var VxeButton = Object.assign(VxeButtonComponent, {
    install: function (app) {
        app.component(VxeButtonComponent.name, VxeButtonComponent);
    }
});
export var Button = VxeButton;
dynamicApp.component(VxeButtonComponent.name, VxeButtonComponent);
export default VxeButton;
